<body class="ltr main-body leftmenu">
  <form>
    <div class="main-content side-content  mt-0 pt-0 pt-0 ml-0">
      <div class="main-container container-fluid mt-0 pt-0">
        <div class="inner-body mt-0 pt-0">
          <div class="row row-sm add-form mt-0 pt-0">
            <div class="card custom-card  mt-0 pt-0">
              <form autocomplete="off" novalidate class="p-0" novalidate [formGroup]="userForm">
                <div class="col-lg-12 col-md-12">
                  <div class="mt-3">
                    <div class="row">
                      <div class="col-md-7">
                        <div class=" d-flex align-items-center pl-3">
                          <img alt="Logo" src="../../assets/img/users.png" class="mh-45px pb-2">
                          <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                User Master
                              </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                              User Information
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3" [formGroup]="UserSearch">
                        <mat-form-field appearance="outline" class="example-full-width2">
                          <mat-label>Search
                          </mat-label> <input class="color" matInput placeholder="Search" formControlName="SearchString"
                            (keyup)="keypress()">
                          <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                      </div>
                      <div class="col-md-1 prpl" *ngIf="viewChangepassword">
                        <button id="addBtn" type="button" class="btn2 btn-primary btn-icon-text mr-5 mt-1"
                          (click)="changePassword()">
                          <span style="display: flex; align-items: center;">
                            <img width="22vh" src="../../assets/img/password.gif" style="margin-right: 7px;">
                            Change Password
                          </span>
                        </button>
                      </div>
                      <div class="col-md-1 prpl">
                        <button id="addBtn" type="button" class="btn btn-primary btn-icon-text  mt-1"
                          (click)="addnewrecord()">
                          <span style="display: flex; align-items: center;">
                            <img width="20vh" src="../../assets/img/plus.gif" style="margin-right: 5px;">
                            New
                          </span>
                        </button>
                      </div>
                    </div>

                    <hr class="mb-2 mt-2 pt-0">

                    <div class="table-responsive table-container mt-3">
                      <table appShortTable id="datatable" class="table table-bordered text-nowrap">
                        <thead>
                          <tr>

                            <th class="f600" width="25%">
                              User Id
                            </th>
                            <th class="f600" width="35%">
                              User Full Name
                            </th>

                            <th class="f600 text-center" width="10%">
                              Action </th>
                          </tr>
                        </thead>
                        <tbody id="table_data">
                          <tr *ngFor="let user of userData;">

                            <td>{{user.LoginName}} </td>
                            <td> {{user.LoginFullName}}</td>
                            <td class="text-center"> <a class="floating mr-2 pr-3" title="Edit"
                                (click)="editData(user)"> <i class="fa fa-edit "></i> </a>

                            </td>
                          </tr>
                        </tbody>
                      </table>

                    </div>

                    <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                      (page)="onPageChange($event)"></mat-paginator>
                  </div>

                </div>
              </form>


            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</body>